<section class="cp-card" aria-labelledby="ph-title">
  <div class="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1">
    <h2 id="ph-title" class="cp-card__title">Pagos</h2>
    @if (rows().length) {
    <p class="text-theme-sm text-gray-500 dark:text-gray-400">
      Ha pagado <span class="font-medium text-gray-800 dark:text-white/90">{{ formatMoney(totalPaid()) }}</span>
    </p>
    }
  </div>

  @if (isLoading() && !history()) {
  <div class="mt-4 space-y-3">
    @for (_ of [1, 2, 3]; track $index) {
    <div class="h-10 animate-pulse rounded-lg bg-gray-100 dark:bg-white/[0.05]"></div>
    }
  </div>
  } @else if (loadFailed()) {
  <p class="mt-4 text-theme-sm text-gray-600 dark:text-gray-300">
    No pudimos cargar los pagos.
    <button type="button" class="ph-link" (click)="load()">Reintentar</button>
  </p>
  } @else if (!rows().length) {
  <p class="mt-4 text-theme-sm text-gray-500 dark:text-gray-400">
    Todavía no tiene pagos. Aparecerán aquí cuando cobres una cita o una venta.
  </p>
  } @else {
  @if (totalPending() > 0) {
  <p class="ph-pending mt-4">
    Debe <strong>{{ formatMoney(totalPending()) }}</strong> de citas sin pagar completas.
  </p>
  }
  <ul class="mt-3 divide-y divide-gray-100 dark:divide-gray-800">
    @for (p of visibleRows(); track p.paymentId) {
    <li class="flex items-center justify-between gap-3 py-3">
      <div class="min-w-0">
        <p class="truncate text-theme-sm font-medium text-gray-800 dark:text-white/90">
          {{ p.serviceName || (p.isAppointment ? 'Cita' : 'Venta de productos') }}
        </p>
        <p class="text-theme-xs text-gray-500 dark:text-gray-400">
          {{ (p.eventDate ?? toDate(p.createdAt)) | date: 'd MMM y' }}{{ methodLabel(p.paymentMethod) ? ', ' + methodLabel(p.paymentMethod) : '' }}
        </p>
      </div>
      <div class="shrink-0 text-right">
        <p class="text-theme-sm font-semibold tabular-nums text-gray-800 dark:text-white/90">{{ formatMoney(p.amount) }}</p>
        <span class="ph-status" [attr.data-status]="p.status">
          @if (p.pending > 0 && p.paidAmount > 0) { Faltan {{ formatMoney(p.pending) }} }
          @else { {{ p.status | paymentStatusEs }} }
        </span>
      </div>
    </li>
    }
  </ul>
  @if (hiddenCount() > 0) {
  <button type="button" class="ph-link mt-1" (click)="expanded.set(!expanded())" [attr.aria-expanded]="expanded()">
    {{ expanded() ? 'Mostrar menos' : 'Ver los ' + rows().length + ' pagos' }}
  </button>
  }
  }
</section>
